import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiEmails } from 'helpers/decorators/api'
import queryString from 'query-string'

@meta({ title: 'Confirm email', intlKey: 'route.confirm_email' })
@apiEmails()
class ConfirmEmail extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    confirmEmail: PropTypes.func.isRequired
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search)

    this.props.confirmEmail(get(query, 'authorizationCode'))
  }

  render() {
    const content = (
      <h1 className="beta text--center">
        <FormattedMessage
          id="moduleTitle.confirming_email_address"
          defaultMessage="Confirming email address ..."
        />
      </h1>
    )

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[content]}
        colWidth="320px"
      />
    )
  }
}

export default ConfirmEmail
